import { render, staticRenderFns } from "./EditConstitucionSociedades.vue?vue&type=template&id=48858f6a&scoped=true"
import script from "./EditConstitucionSociedades.vue?vue&type=script&lang=js"
export * from "./EditConstitucionSociedades.vue?vue&type=script&lang=js"
import style0 from "./EditConstitucionSociedades.vue?vue&type=style&index=0&id=48858f6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48858f6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48858f6a')) {
      api.createRecord('48858f6a', component.options)
    } else {
      api.reload('48858f6a', component.options)
    }
    module.hot.accept("./EditConstitucionSociedades.vue?vue&type=template&id=48858f6a&scoped=true", function () {
      api.rerender('48858f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/tasks/EditConstitucionSociedades.vue"
export default component.exports